import { defineStore } from "pinia";
import agenciesColumns from '@/state/tableSettings/agenciesColumns.json';
import teamsColumns from '@/state/tableSettings/teamsColumns.json';
import bookingsColumns from '@/state/tableSettings/bookingsColumns.json';
import addressesColumns from '@/state/tableSettings/addressesColumns.json';

const tableDefaults = {
  agenciesTable: agenciesColumns,
  teamsTable: teamsColumns,
  bookingsTable: bookingsColumns,
  addressesTable: addressesColumns
};

export const useTableSettings = defineStore("tableSettings", {
  state: () => ({
    agenciesTable: JSON.parse(window.localStorage.getItem("waos_rm.agenciesTable")) || tableDefaults.agenciesTable,
    teamsTable: JSON.parse(window.localStorage.getItem("waos_rm.teamsTable")) || tableDefaults.teamsTable,
    bookingsTable: JSON.parse(window.localStorage.getItem("waos_rm.bookingsTable")) || tableDefaults.bookingsTable,
    addressesTable: JSON.parse(window.localStorage.getItem("waos_rm.addressesTable")) || tableDefaults.addressesTable,
  }),
  actions: {
    columns(table){
      if (this[table] === undefined) {
        return [];
      }
      if (this[table].version !== tableDefaults[table].version){
        this.loadDefaults(table);
      }
      return this[table].columns;
    },
    ordering(table){
      if (this[table] !== undefined) {
        return {field: this[table].sortField, direction: this[table].sortOrder}
      }else{
        return {field: null, direction: null}
      }
    },
    setColumns(table, columns){
      this[table].columns = columns;
    },
    setSortField(property, table){
      if (this[table].sortField === property) {
        if (this[table].sortOrder === 'asc') {
          this[table].sortOrder = 'desc';
        } else {
          this[table].sortOrder = 'asc';
        }
      } else {
        this[table].sortOrder = 'asc';
        this[table].sortField = property
      }
      this.save(table)
    },
    save(table) {
      window.localStorage.setItem(`waos_rm.${table}`, JSON.stringify(this[table]));
    },
    selectAll(table){
      this[table].columns.forEach((c) => {
        c.active = true;
      })
    },
    unSelectAll(table){
      this[table].columns.forEach((c) => {
        if (c.required === false) {
          c.active = false;
        }
      })
    },
    loadDefaults(table){
      this[table] =  JSON.parse(JSON.stringify(tableDefaults[table]));
      window.localStorage.setItem(`waos_rm.${table}`, JSON.stringify(tableDefaults[table]));
    },
  }
});
